import styled, { css } from 'styled-components';

import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export type ResponsiveVisibilityProps = {
    $target?: 'desktop' | 'mobile';
};

export const responsiveVisibility = ($target: 'desktop' | 'mobile') => css`
    ${$target === 'desktop'
        ? css`
              display: none;

              ${purpurMedia('lg')`
                  display: flex;
              `}
          `
        : css`
              display: flex;

              ${purpurMedia('lg')`
                  display: none;
              `}
          `}
`;

export const withResponsiveVisibilityMixin = css<ResponsiveVisibilityProps>`
    ${({ $target }) => ($target ? responsiveVisibility($target) : '')}
`;

export const ColumnsContainer = styled.div`
    max-width: 69.75rem;
    margin: 0 auto;
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('600')};
    gap: ${getPurpurSpacing('400')};

    ${purpurMedia('lg')`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: ${getPurpurSpacing('800')};
        padding-bottom: ${getPurpurSpacing('1000')};
    `}
`;

export const ArticleContentColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('600')};

    ${purpurMedia('lg')`
        max-width: 34.125rem;
        flex-grow: 1;
    `}
`;

export const ArticleTopContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};
`;

export const ArticleMetaColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('400')};
    padding-top: ${getPurpurSpacing('800')};

    ${purpurMedia('lg')`
        gap: ${getPurpurSpacing('600')};
        padding-top: 0;
        max-width: 27rem;
        flex-grow: 1;
    `}
`;

export const ArticleSummary = styled.div`
    font-size: ${getPurpurTypography('scale200')};

    ${purpurMedia('md')`
        font-size: ${getPurpurTypography('scale300')};
    `}

    ${purpurMedia('lg')`
        font-size: ${getPurpurTypography('scale400')};
    `}
`;

export const PublishDate = styled.div`
    color: ${getPurpurColor('textMedium')};
    font-size: ${getPurpurTypography('scale75')};
    line-height: ${getPurpurTypography('lineHeightLoose')};
`;

export const MetaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};
`;

export const StyledArticleTableOfContents = styled.div<ResponsiveVisibilityProps>`
    ${withResponsiveVisibilityMixin}
`;

export const ArticleAuthors = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};
`;

export const StyledArticleCategoryAndDate = styled.div<ResponsiveVisibilityProps>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: ${getPurpurSpacing('200')};

    ${withResponsiveVisibilityMixin}
`;

export const CategoriesList = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};
    margin: 0;
    padding: 0;
    line-height: 1;
`;
